var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2512 19.6549C24.6742 19.6549 31.5024 17.082 31.5024 13.9081C31.5024 10.7342 24.6742 8.16125 16.2512 8.16125C7.8282 8.16125 1 10.7342 1 13.9081C1 17.082 7.8282 19.6549 16.2512 19.6549Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2085 16.7815C15.42 23.9804 21.0919 28.5297 23.8771 26.9428C26.6623 25.3559 25.5061 18.2335 21.2945 11.0347C17.083 3.83578 11.4111 -0.713591 8.62592 0.87335C5.84073 2.46029 6.99699 9.58261 11.2085 16.7815Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2083 11.0347C6.99676 18.2335 5.8405 25.3559 8.62569 26.9428C11.4109 28.5297 17.0828 23.9804 21.2943 16.7815C25.5058 9.58261 26.6621 2.4603 23.8769 0.873354C21.0917 -0.713587 15.4198 3.83579 11.2083 11.0347Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2514 16.713C17.8212 16.713 19.0937 15.4571 19.0937 13.908C19.0937 12.3588 17.8212 11.103 16.2514 11.103C14.6817 11.103 13.4092 12.3588 13.4092 13.908C13.4092 15.4571 14.6817 16.713 16.2514 16.713Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactIcon);
export default __webpack_public_path__ + "static/media/React-icon.56c02f9372783ea9b9c19acebd30e915.svg";
export { ForwardRef as ReactComponent };